module.exports = __webpack_public_path__ + "static/media/icon-cross.bab1b4f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-cross.svg
// module id = 267
// module chunks = 3